import { useCallback, useState } from "react"

export function useReloadKey() {
  const [state, setState] = useState(0)

  const triggerReload = useCallback(() => {
    setState(key => key + 1)
  }, [])

  return [state, triggerReload] as const
}
